import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

const Partner = () => {
  return (
    <div className="partner-usa p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="partner_content">
              <h2>Collaborate with Leading Enterprise App Developers</h2>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <p>
              When it comes to building robust solutions for your business,
              choose TekRevol, the trusted enterprise{" "}
              <Link to="https://www.tekrevol.com/mobile-app-development">
                mobile app development company
              </Link>
              .{" "}
            </p>
            <p>
              Collaborate with our leading developers to bring your vision to
              life. We focus on delivering results that drive your business
              forward.
            </p>
          </Col>
        </Row>
        <Row className="h-100 partner_padd">
          <Col xs={12} md={4} lg={4} xl={4} xxl={4}>
            <div className="partner-num">4.5</div>
            <div className="partner-para">
              <p>Average Review Rating on Glassdoor</p>
            </div>
          </Col>
          <Col xs={12} md={4} lg={4} xl={4} xxl={4}>
            <div className="partner-num">4.8</div>
            <div className="partner-para">
              <p>Average Review Rating on RightFirms</p>
            </div>
          </Col>
          <Col xs={12} md={4} lg={4} xl={4} xxl={4}>
            <div className="partner-num">4.8</div>
            <div className="partner-para">
              <p>Average Review Rating on Clutch</p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Partner;
